import { documentPdfSource } from 'features/knowledgeDocumentViewer/artifacts/pdf/FreeformDocumentPdf'
import { renderArtifactPdfBlob } from 'features/knowledgeDocumentViewer/artifacts/pdf/RenderArtifactPdfBlob'
import { DocumentSheet } from 'features/knowledgeDocumentViewer/artifacts/sheet/DocumentSheet'
import { FreeformDocumentSheet } from 'features/knowledgeDocumentViewer/artifacts/sheet/FreeformDocumentSheet'
import type { DocumentArtifact } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import React from 'react'

import type { ArtifactKindRenderer } from './index'

function DocumentBody({
  artifact,
  changedPaths,
}: {
  artifact: DocumentArtifact
  changedPaths: string[]
}): React.ReactElement {
  return (
    <DocumentSheet testId='artifact-sheet'>
      <FreeformDocumentSheet artifact={artifact} changedPaths={changedPaths} />
    </DocumentSheet>
  )
}

export const documentKind: ArtifactKindRenderer<DocumentArtifact> = {
  Body: DocumentBody,
  download: {
    extension: 'pdf',
    mimeType: 'application/pdf',
    render: (artifact) => renderArtifactPdfBlob(documentPdfSource(artifact)),
  },
}
